<!--
 * @Description: 访客计划 -- 查看页面
 * @Author: mdb
 * @Date: 2022-07-19 11:12:06
 * @LastEditTime: 2023-03-13 14:45:33
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
        <a-tabs v-model:activeKey="activeTabs" @change="handleTabsChange">
          <a-tab-pane key="info" :tab="t('common.baseTabs')">
            <VisitorProgramForm
              ref="visitorProgramFormRef"
              :title="t('clue.visitorDetailTitile')"
              v-model:value="dataForm"
              type="view"
              :isEdit="false"
            />
          </a-tab-pane>
          <a-tab-pane key="logs" :tab="t('common.operationLogTabs')">
            <TabsOperationLog appId="cos_ofbu" tableId="DcCosOFbuVisitorOperationLog" :resourceId="route.query.id as string" />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
    </dc-layout-content>

    <cos-footer-button :hideOk="true">
      <SellerButton
        v-permission="'ofbu_visitor_edit_btn'"
        :workCode="dataForm.dutyBy"
        controlType="none"
        v-if="dataForm.status !== 3"
        @click="handleEdit()"
        >{{ t('btn.edit') }}</SellerButton
      >
      <SellerButton
        v-permission="'ofbu_visitor_complete_btn'"
        :workCode="dataForm.dutyBy"
        controlType="none"
        v-if="dataForm.status !== 3"
        type="primary"
        @click="handleVisitComplete()"
        >{{ t('btn.completeVisit') }}</SellerButton
      >
    </cos-footer-button>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { ref, reactive, onBeforeMount } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramDetail } from '@/api/overseasSales/followUpManage'
import type { FbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()

const dataForm = reactive<FbuVisitorProgramEditParams>({})

onBeforeMount(() => {
  visitorProgramDetail(route.query.id as string).then((res) => {
    Object.assign(dataForm, res.data)
  })
})

const activeTabs = ref('info')
const handleTabsChange = (val: any) => {
  console.log(val)
}

const visitorProgramFormRef = ref()
const handleVisitComplete = (row = dataForm) => {
  router.push({ path: '/ofbu/followUpRecord/visitingPlan', query: { planId: row.id } })
}
const handleEdit = () => {
  router.push({ path: '/ofbu/visitorProgram/edit', query: { id: route.query.id as string } })
}
</script>
<script lang="ts">
export default { name: 'DcCosOFbuVisitorProgramView' }
</script>

<style scoped></style>
